var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$locale['object']['jobs-main-banner'])?_c('main',{staticClass:"jobs-container"},[_c('GlobalMainBanner',{attrs:{"bannerData":_vm.$locale['object']['jobs-main-banner']}}),_c('JobOffers')],1):_c('Spinner')
}
var staticRenderFns = []

export { render, staticRenderFns }